<div id="navbar">
  <agingplan-navbar
    brand_title="AgingPlan"
    [logo_url]="env.google.bucket + navigationService.logo"
    [theme]="navigationService.navbar_theme"
    [items]="public_nav_items"
    [auth_state]="authState$ | async"
    [home_route]="'/'"
    [is_opaque]="is_opaque"
    [sidebar_visible]="sidebar_visible"
    (onAuthClick)="onAuthClick($event)"
    (onContentOutletClick)="loadContentOutlet($event)"
    (onCloseClick)="onCloseClick()"></agingplan-navbar>
</div>

<popover-content-outlet #cost_of_care_popover (onClosed)="is_opaque = false" [show_close_button]="true">
  <app-cost-of-care-map></app-cost-of-care-map>
</popover-content-outlet>

<popover-content-outlet #popover_book_us (onClosed)="is_opaque = false" [show_close_button]="true">
  <app-book-us></app-book-us>
</popover-content-outlet>
